var map = {
	"./en.json": "./src/locales/translations/en.json",
	"./es.json": "./src/locales/translations/es.json",
	"./fr.json": "./src/locales/translations/fr.json",
	"./ja.json": "./src/locales/translations/ja.json",
	"./pt.json": "./src/locales/translations/pt.json"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/locales/translations sync recursive ^\\.\\/.*\\.json$";